import React from "react";

import { Link } from "react-router-dom";
import { SOCIAL_LINKS_DATA } from "../../../../constants/content/shared/footer/social-links";

import "./styles.scss";

const SocialLinks = () => {
  return (
    <div className="SocialLinks">
      {SOCIAL_LINKS_DATA.map((link) => (
        <Link className="SocialLinks-link" to={link.link} key={link.title}>
          {link.title}
        </Link>
      ))}
    </div>
  );
};

export default SocialLinks;
